
import {message} from "./message";

var key = "VGhpcyB2ZXJzaW9uIG9mIFdlYml4IGlzIG5vdCBpbnRlbmRlZCBmb3IgdXNpbmcgb3V0c2lkZSBvZiB3ZWJpeC5jb20=";
var url = document.location.href;
if (window.atob && url.indexOf(atob("d2ViaXguY29tLw==")) == -1 && url.indexOf(atob("d2ViaXhjb2RlLmNvbS8=")) == -1)
	setTimeout(function(){
		message({ type:"error", text:atob(key), expire: -1 });	
	}, Math.floor(Math.random()*5000) + 1000);